import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type { OnboardingIndustry } from "./selfOnboardingOptions";

export type IndustryProof = {
  stat: { value: string; label: MessageDescriptor };
  testimonial: {
    quote: MessageDescriptor;
    author: MessageDescriptor;
    business: MessageDescriptor;
  };
};

// Figures and quotes as published on business.lime-booking.com.
function getStat(): IndustryProof["stat"] {
  return {
    value: "70 %",
    label: msg`manj neprihodov z avtomatskimi opomniki`,
  };
}

function getBarberProof(): IndustryProof {
  return {
    stat: getStat(),
    testimonial: {
      quote: msg({
        message:
          "Ne rabim se več ves čas javljati na telefon. Dejansko imamo mi nekje sam 7% klicev, tko da do the math! Vsi so navajeni na spletno naročanje.",
        comment:
          "Customer testimonial. Replace quote, author and business with a local customer's own words where one exists.",
      }),
      author: msg({
        message: "Edis",
        comment:
          "Customer testimonial. Replace quote, author and business with a local customer's own words where one exists.",
      }),
      business: msg({
        message: "Barber Room by Edis",
        comment:
          "Customer testimonial. Replace quote, author and business with a local customer's own words where one exists.",
      }),
    },
  };
}

function getGeneralProof(): IndustryProof {
  return {
    stat: getStat(),
    testimonial: {
      quote: msg({
        message:
          "Lime Booking je super, saj se lahko stranke naročijo 24/7, kadar želijo. Ne potrebujejo me nič kontaktirati, samo poklikajo in imajo takoj termin.",
        comment:
          "Customer testimonial. Replace quote, author and business with a local customer's own words where one exists.",
      }),
      author: msg({
        message: "Anja",
        comment:
          "Customer testimonial. Replace quote, author and business with a local customer's own words where one exists.",
      }),
      business: msg({
        message: "Studio Trepka",
        comment:
          "Customer testimonial. Replace quote, author and business with a local customer's own words where one exists.",
      }),
    },
  };
}

export const TRUSTED_BY_COUNT = "2000+";

export function getIndustryProof(
  industry: OnboardingIndustry | null,
): IndustryProof {
  return industry === "Brivci" ? getBarberProof() : getGeneralProof();
}
